import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Check, ArrowRight } from 'lucide-react';

const OrderConfirmation = () => {
  const location = useLocation();
  const orderId = location.state?.orderId;

  return (
    <div className="bg-black min-h-screen pt-32 pb-16">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center">
          <div className="bg-green-600/20 border-2 border-green-500 rounded-full w-24 h-24 flex items-center justify-center mx-auto mb-8">
            <Check size={48} className="text-green-400" />
          </div>

          <h1 className="text-4xl font-bold text-white mb-4" data-testid="confirmation-title">
            Commande <span className="text-green-400">Confirmée</span> !
          </h1>

          <p className="text-xl text-gray-300 mb-2">
            Merci pour votre commande chez La Casa Del Pizza !
          </p>

          {orderId && (
            <p className="text-gray-400 mb-8">
              Numéro de commande : <span className="text-white font-mono font-bold">#{orderId.slice(0, 8)}</span>
            </p>
          )}

          <div className="bg-gradient-to-br from-gray-900 to-black border border-red-600/30 rounded-xl p-8 mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">Et maintenant ?</h2>
            <div className="space-y-4 text-left">
              <div className="flex items-start gap-4">
                <div className="bg-red-600 rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-white font-bold text-sm">1</span>
                </div>
                <div>
                  <p className="text-white font-semibold">Commande reçue</p>
                  <p className="text-gray-400 text-sm">Notre équipe prépare votre commande avec soin</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="bg-red-600 rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-white font-bold text-sm">2</span>
                </div>
                <div>
                  <p className="text-white font-semibold">Cuisson au feu de bois</p>
                  <p className="text-gray-400 text-sm">Vos pizzas sont cuites dans notre four traditionnel</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="bg-red-600 rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-white font-bold text-sm">3</span>
                </div>
                <div>
                  <p className="text-white font-semibold">Livraison en 30 min</p>
                  <p className="text-gray-400 text-sm">Votre commande arrive chaude et croustillante !</p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button
                size="lg"
                className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-bold text-lg px-8"
                data-testid="back-home-btn"
              >
                Retour à l'accueil
                <ArrowRight size={20} className="ml-2" />
              </Button>
            </Link>
            <a href="tel:0767682464">
              <Button
                size="lg"
                variant="outline"
                className="border-2 border-gray-700 text-gray-300 hover:bg-gray-900 hover:text-white font-semibold text-lg px-8"
              >
                Appeler : 07 67 68 24 64
              </Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;
